import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ViewChild, OnInit, inject } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { LocationListComponent } from '../location-list/location-list.component';
import { LocationMapComponent } from "../user-details/location-map/location-map.component";
import { FormsModule } from '@angular/forms';
import { DeviceLocationService } from '@app/shared/_services/device-location.service';





@Component({
  selector: 'app-view-user-locations',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, LocationListComponent, LocationMapComponent],
  templateUrl: './view-user-locations.component.html',
  styleUrl: './view-user-locations.component.css'
})
export class ViewUserLocationsComponent implements OnInit, AfterViewInit {
  locations: any[] = [];
  userId: string = '';
  startDateInput: string = '';
  endDateInput: string = '';
  @ViewChild(LocationListComponent) locationListComponent!: LocationListComponent;
  ngOnInit(): void {
    this.userId = this.activatedRoute.snapshot.params['userId'];
    this.setDefaultDateRange();
  }
  private activatedRoute = inject(ActivatedRoute);
  private deviceLocationService = inject(DeviceLocationService);




  
  private toInputDateTimeLocalString(date: Date): string {
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
  }

  private setDefaultDateRange(): void {
    const now = new Date();
    const yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000);
    this.endDateInput = this.toInputDateTimeLocalString(now);
    this.startDateInput = this.toInputDateTimeLocalString(yesterday);
  }

  ngAfterViewInit(): void {
    this.loadLocations();
  }

  private getValidatedRange(): { start: Date; end: Date } | null {
    if (!this.startDateInput || !this.endDateInput) {
      return null;
    }

    const start = new Date(this.startDateInput);
    const end = new Date(this.endDateInput);

    if (isNaN(start.getTime()) || isNaN(end.getTime()) || start > end) {
      return null;
    }

    return { start, end };
  }

  loadLocations(): void {
    const range = this.getValidatedRange();
    if (!range || !this.locationListComponent) {
      return;
    }
    this.locationListComponent.loadLocationsByRange(
      this.startDateInput,
      this.endDateInput
    );
  }

  downloadLocations(): void {
    const range = this.getValidatedRange();
    if (!range || !this.userId) {
      return;
    }
    this.deviceLocationService.downloadUserLocationKmlFile(
      range.start,
      range.end,
      this.userId
    );
  }

}
